import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ComplexGrid from "./complexGrid"
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function BasicTable(props) {
  const classes = useStyles();
  const t = useTranslation()[0];

  if (!props.availableTechnicians || props.availableTechnicians.fetchError) {
    return null;
  }

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{t("availableTechnician.title")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.availableTechnicians.map((row) => (
            <TableRow key={row.technician.name}>
              <TableCell align="right">
                  <ComplexGrid {...row}></ComplexGrid>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
